import applyRegex from "./applyRegex";

export function handleChangeNumber(set, value) {
    set(applyRegex(value.replace('e', ''), /\d+/));
}